import { ReactNode } from "react";

import { EmailIcon } from "@/assets/svgs";
import { LogoImage } from "@/assets/pngs";
import { IMAGE_URLS } from "@/utils/constants";
import ImageSlider from "@/components/ui/imageSlider";
import { useOrganizationData } from "@/store/hooks";

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { organization } = useOrganizationData();

  return (
    <div className="min-h-dvh w-full flex flex-col">
      <nav className="absolute top-0 w-full flex justify-center sm:justify-between items-center px-8 pt-4 h-[70px] z-10">
        <div className="max-w-[257px] h-[50px] flex items-start">
          <img
            src={organization?.logo || LogoImage}
            alt="Logo"
            className="w-full h-full object-contain"
          />
        </div>

        <div className="hidden items-center gap-2 sm:flex">
          <span className="text-sm leading-none pt-0.5">Have a question?</span>
          <a
            href="#"
            className="gap-1 flex items-center text-sm text-primary-600 px-4 py-1 rounded-[36px] bg-white"
          >
            <EmailIcon className="flex-shrink-0 text-primary-600" />
            <span className="leading-none pt-0.5">Contact us</span>
          </a>
        </div>
      </nav>

      <div className="min-h-dvh flex justify-center">
        {/* Left Section - Content */}
        <div className="w-full lg:w-1/2 flex flex-col">
          <div className="flex-1 flex items-center justify-center">
            <div className="w-full max-w-[718px] px-5 lg:px-14">{children}</div>
          </div>
        </div>

        {/* Right Section - Image Slider */}
        <div className="w-1/2 hidden lg:block">
          <ImageSlider
            images={[
              IMAGE_URLS.AUTH_LAYOUT_SLIDER1,
              IMAGE_URLS.AUTH_LAYOUT_SLIDER2,
              IMAGE_URLS.AUTH_LAYOUT_SLIDER3,
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
